/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Category_FinInputs */

const en_category_fin = /** @type {(inputs: Category_FinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finance & Crypto`)
};

const zh_hans1_category_fin = /** @type {(inputs: Category_FinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`金融与加密货币`)
};

const pt_br2_category_fin = /** @type {(inputs: Category_FinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finanças e cripto`)
};

const es_category_fin = /** @type {(inputs: Category_FinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finanzas y cripto`)
};

const fr_category_fin = /** @type {(inputs: Category_FinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finance et crypto`)
};

const de_category_fin = /** @type {(inputs: Category_FinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finanzen & Krypto`)
};

const ru_category_fin = /** @type {(inputs: Category_FinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Финансы и крипто`)
};

const it_category_fin = /** @type {(inputs: Category_FinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finanza e crypto`)
};

/**
* | output |
* | --- |
* | "Finance & Crypto" |
*
* @param {Category_FinInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const category_fin = /** @type {((inputs?: Category_FinInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Category_FinInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_category_fin(inputs)
	if (locale === "pt-BR") return pt_br2_category_fin(inputs)
	if (locale === "es") return es_category_fin(inputs)
	if (locale === "fr") return fr_category_fin(inputs)
	if (locale === "de") return de_category_fin(inputs)
	if (locale === "ru") return ru_category_fin(inputs)
	if (locale === "it") return it_category_fin(inputs)
	return en_category_fin(inputs)
});